(function () {
    'use strict';

    angular
        .module('auditMandateEditModule', [
        ]);
})();